export enum FaqNodeType {
    FOLDER = 'folder',
    PAGE = 'page'
}
